// extracted by mini-css-extract-plugin
module.exports = {"container":"AdvancedCard_container__AI2q4","img":"AdvancedCard_img__38NbM","title":"AdvancedCard_title__3F_IR","description":"AdvancedCard_description__2bkFV"};